export const table1 = {
  title: "Oyster vs. Copy.AI ",
  row: ["FEATURES", "COMMENT", "OYSTER", "COPY.AI"],
  rowData: [
    {
      Feature: "AI Tech",
      Comment:
        "Oyster employs cutting-edge language AI, enhanced with industry-specific best practices and templates. ",
      Oyster: "GPT-4 + Proprietary",
      Platform: "GPT-3",
    },
    {
      Feature: "Output quality ",
      Comment:
        "Oyster delivers a superior, professionally polished output that demands minimal to no editing.  ",
      Oyster: "9/10 ",
      Platform: "8/10 ",
    },
    {
      Feature: "Editor ",
      Comment:
        "Oyster presents a straightforward document-style editor, creating an environment free from distractions, ideal for seamless long-form writing. Perfect for crafting blogs, articles, essays, and more. ",
      Oyster: "Yes",
      Platform: "No",
    },
    {
      Feature: "Workflow Management ",
      Comment:
        "Oyster enables an effortless organisation and structuring of your work into documents, enhancing management, editing, and sharing capabilities. ",
      Oyster: "Yes",
      Platform: "No",
    },
    {
      Feature: "Supported use cases ",
      Comment:
        "Oyster supports a wide range of commonly sought-after use cases, and it also offers unique, exclusive functionalities that set it apart from other platforms.  ",
      Oyster: "50+ cases Upcoming ",
      Platform: "70+",
    },
    {
      Feature: "Supported languages ",
      Comment:
        "Access support for all major languages with Oyster, leveraging its proprietary methodology for generating outputs in different languages to guarantee superior quality.  ",
      Oyster: "GPT-4 + Proprietary",
      Platform: "GPT-3",
    },

    {
      Feature: "Browser extension ",
      Comment:
        "An extension that seamlessly integrates with your web activities, whether it's email, social media, document editing, WordPress, or other online tasks. ",
      Oyster: "Upcoming ",
      Platform: "Yes",
    },
    {
      Feature: "Plagiarism Checker ",
      Comment:
        "Oyster incorporates a built-in plagiarism checker to instantly assess the originality of generated content and provide prompt feedback. ",
      Oyster: "Yes + report can be downloaded as a pdf file ",
      Platform: "No",
    },
    {
      Feature: "SEO",
      Comment:
        "Oyster includes an integrated SEO toolkit designed for seamless optimization of long-form content as you write, supporting up to 10 long-tail and 10 short-tail keywords. ",
      Oyster: "Yes + Proprietary ",
      Platform: "No Plan",
    },
    {
      Feature: "Customer support ",
      Comment:
        "Oyster provides exceptionally swift, dependable, and friendly customer support, actively soliciting continuous feedback from customers. Ticket resolutions are typically achieved within 12 hours. ",
      Oyster: "Upcoming  ",
      Platform: "  9/10 ",
    },
    {
      Feature: "Community",
      Comment:
        "Join an exclusive community tailored for entrepreneurs and startups, offering insights not only on writing but also on marketing strategies and business development.",
      Oyster: "Upcoming ",
      Platform: "Yes",
    },
    {
      Feature: "Character limits ",
      Comment:
        "With Oyster's premium plan, you have the freedom to generate an unlimited number of characters every month. ",
      Oyster: "Unlimited ",
      Platform: "Unlimited ",
    },
    {
      Feature: "Mobile Friendly ",
      Comment:
        "Oyster boasts lightning-fast speed and complete mobile optimisation, enabling you to write and edit seamlessly on the move without overlooking any crucial details. ",
      Oyster: "Yes",
      Platform: "No",
    },
    {
      Feature: "Free trial ",
      Comment:
        "Oyster extends a lifetime free plan, enabling you to generate up to 10,000 characters monthly without the necessity of a credit card. ",
      Oyster:
        "10k characters per month forever without a credit card requirement ",
      Platform: "Yes - need to enter credit card details. 7-Day Free Trial ",
    },
    {
      Feature: "Monthly price",
      Comment:
        "Oyster stands out as an exceptionally cost-effective tool, providing excellent value for money through its quality and features. ",
      Oyster: "$13 ",
      Platform: "$49",
    },
    {
      Feature: "Annual price ",
      Comment:
        "Subscribe to Oyster's premium annual plan for access to outstanding features at a budget-friendly price. ",
      Oyster: "$130 ",
      Platform: "$9.99 (Starter), $35.60 (Professional), $179.60 (Business) ",
    },
  ],
};
export const table2 = {
  title: "Oyster vs. Writesonic ",
  row: ["FEATURES", "COMMENT", "OYSTER", "Writesonic"],
  rowData: [
    {
      Feature: "AI Tech",
      Comment:
        "Oyster harnesses advanced language AI, complemented by specialised best practices and templates designed for specific use cases. ",
      Oyster: "GPT-4 + Proprietary",
      Platform: "GPT-3",
    },
    {
      Feature: "Output quality ",
      Comment:
        "Oyster delivers a superior, professionally polished output that demands minimal to no editing.  ",
      Oyster: "9/10 ",
      Platform: "8.5/10 ",
    },
    {
      Feature: "Editor ",
      Comment:
        "Oyster presents a straightforward document-style editor, creating an environment free from distractions, ideal for seamless long-form writing. Perfect for crafting blogs, articles, essays, and more. ",
      Oyster: "Yes",
      Platform: "Yes",
    },
    {
      Feature: "Workflow Management ",
      Comment:
        "Oyster lets you easily organise and structure your work in documents for better management, editing, and sharing  ",
      Oyster: "Yes",
      Platform: "No",
    },
    {
      Feature: "Supported use cases ",
      Comment:
        "Oyster supports a wide range of commonly sought-after use cases. It also offers unique, exclusive functionalities that sets it apart from other platforms.  ",
      Oyster: "50+ cases Upcoming ",
      Platform: "21",
    },
    {
      Feature: "Supported languages ",
      Comment:
        "Access support for all major languages with Oyster, leveraging its proprietary methodology for generating outputs in different languages to guarantee superior quality.",
      Oyster: "15+ languages Upcoming ",
      Platform: "24",
    },

    {
      Feature: "Browser extension ",
      Comment:
        "An extension that seamlessly integrates with your web activities, whether it's email, social media, document editing, WordPress, or other online tasks. ",
      Oyster: "Yes ",
      Platform: "No",
    },
    {
      Feature: "Plagiarism Checker ",
      Comment:
        "Oyster incorporates a built-in plagiarism checker to instantly assess the originality of generated content and provide prompt feedback. ",
      Oyster: "Yes + report can be downloaded as a pdf file ",
      Platform: "No",
    },
    {
      Feature: "SEO",
      Comment:
        "Oyster includes an integrated SEO toolkit designed for seamless optimization of long-form content as you write, supporting up to 10 long-tail and 10 short-tail keywords. ",
      Oyster: "Yes + Proprietary ",
      Platform: "Basic",
    },
    {
      Feature: "Customer support ",
      Comment:
        "Oyster provides exceptionally swift, dependable, and friendly customer support, actively soliciting continuous feedback from customers. Ticket resolutions are typically achieved within 12 hours. ",
      Oyster: "Upcoming  ",
      Platform: "  8/10 ",
    },
    {
      Feature: "Community",
      Comment:
        "Join an exclusive community tailored for entrepreneurs and startups, offering insights not only on writing but also on marketing strategies and business development.",
      Oyster: "Upcoming ",
      Platform: "No",
    },
    {
      Feature: "Character limits ",
      Comment:
        "With Oyster's premium plan, you have the freedom to generate an unlimited number of characters every month. ",
      Oyster: "Unlimited ",
      Platform:
        "75 credits (Starter), unlimited (Professional), unlimited (Business)  ",
    },
    {
      Feature: "Mobile Friendly ",
      Comment:
        "Oyster boasts lightning-fast speed and complete mobile optimisation, enabling you to write and edit seamlessly on the move without overlooking any crucial details. ",
      Oyster: "Yes",
      Platform: "No",
    },
    {
      Feature: "Free trial ",
      Comment:
        "Oyster extends a lifetime free plan, enabling you to generate up to 10,000 characters monthly without the necessity of a credit card. ",
      Oyster:
        "10k characters per month forever without a credit card requirement ",
      Platform: "60% off on all of their plans, Free Trial (10 credits)  ",
    },
    {
      Feature: "Monthly price",
      Comment:
        "Oyster stands out as an exceptionally cost-effective tool, providing excellent value for money through its quality and features. ",
      Oyster: "$13 ",
      Platform: "$11.60 (Starter), $39.60 (Professional), $199.60 (Business) ",
    },
    {
      Feature: "Annual price ",
      Comment:
        "Subscribe to Oyster's premium annual plan for access to outstanding features at a budget-friendly price. ",
      Oyster: "$130 ",
      Platform: "$9.99 (Starter), $35.60 (Professional), $179.60 (Business) ",
    },
  ],
};

export const table3 = {
  title: "Oyster vs. Peppertype  ",
  row: ["FEATURES", "COMMENT", "OYSTER", "PEPPERTYPE "],
  rowData: [
    {
      Feature: "AI Tech",
      Comment:
        "Oyster employs cutting-edge language AI, enhanced with industry-specific best practices and templates.  ",
      Oyster: "GPT-4 + Proprietary",
      Platform: "GPT-3",
    },
    {
      Feature: "Output quality ",
      Comment:
        "Oyster delivers a superior, professionally polished output that demands minimal to no editing.  ",
      Oyster: "9/10 ",
      Platform: "8/10 ",
    },
    {
      Feature: "Editor ",
      Comment:
        "Oyster presents a straightforward document-style editor, creating an environment free from distractions, ideal for seamless long-form writing. Perfect for crafting blogs, articles, essays, and more. ",
      Oyster: "Yes",
      Platform: "No",
    },
    {
      Feature: "Workflow Management ",
      Comment:
        "Oyster lets you easily organise and structure your work in documents for better management, editing, and sharing  ",
      Oyster: "Yes",
      Platform: "Yes",
    },
    {
      Feature: "Supported use cases ",
      Comment:
        "Oyster supports a wide range of commonly sought-after use cases. It also offers unique, exclusive functionalities that sets it apart from other platforms.  ",
      Oyster: "50+ cases Upcoming ",
      Platform: "34",
    },
    {
      Feature: "Supported languages ",
      Comment:
        "Access support for all major languages with Oyster, leveraging its proprietary methodology for generating outputs in different languages to guarantee superior quality.",
      Oyster: "15+ languages Upcoming ",
      Platform: "1",
    },

    {
      Feature: "Browser extension ",
      Comment:
        "An extension that seamlessly integrates with your web activities, whether it's email, social media, document editing, WordPress, or other online tasks. ",
      Oyster: "Upcoming",
      Platform: "No",
    },
    {
      Feature: "Plagiarism Checker ",
      Comment:
        "Oyster incorporates a built-in plagiarism checker to instantly assess the originality of generated content and provide prompt feedback. ",
      Oyster: "Yes + report can be downloaded as a pdf file ",
      Platform: "Yes, but limited to the enterprise plan only ",
    },
    {
      Feature: "SEO",
      Comment:
        "Oyster includes an integrated SEO toolkit designed for seamless optimization of long-form content as you write, supporting up to 10 long-tail and 10 short-tail keywords. ",
      Oyster: "Yes + Proprietary ",
      Platform: "Yes",
    },
    {
      Feature: "Customer support ",
      Comment:
        "Oyster provides exceptionally swift, dependable, and friendly customer support, actively soliciting continuous feedback from customers. Ticket resolutions are typically achieved within 12 hours. ",
      Oyster: "Upcoming  ",
      Platform: "  8",
    },
    {
      Feature: "Community",
      Comment:
        "Join an exclusive community tailored for entrepreneurs and startups, offering insights not only on writing but also on marketing strategies and business development.",
      Oyster: "Upcoming ",
      Platform: "Yes",
    },
    {
      Feature: "Character limits ",
      Comment:
        "With Oyster's premium plan, you have the freedom to generate an unlimited number of characters every month. ",
      Oyster: "Unlimited ",
      Platform: "Unlimited ",
    },
    {
      Feature: "Mobile Friendly ",
      Comment:
        "Oyster boasts lightning-fast speed and complete mobile optimisation, enabling you to write and edit seamlessly on the move without overlooking any crucial details. ",
      Oyster: "Yes",
      Platform: "Yes",
    },
    {
      Feature: "Free trial ",
      Comment:
        "Oyster extends a lifetime free plan, enabling you to generate up to 10,000 characters monthly without the necessity of a credit card. ",
      Oyster:
        "10k characters per month forever without a credit card requirement ",
      Platform: "10k words ",
    },
    {
      Feature: "Monthly price",
      Comment:
        "Oyster stands out as an exceptionally cost-effective tool, providing excellent value for money through its quality and features. ",
      Oyster: "$13 ",
      Platform: "Starts from $35 ",
    },
    {
      Feature: "Annual price ",
      Comment:
        "Subscribe to Oyster's premium annual plan for access to outstanding features at a budget-friendly price. ",
      Oyster: "$130 ",
      Platform: "Starts from $300 ",
    },
  ],
};

export const table4 = {
  title: "Oyster vs. ChatGPT ",
  row: ["FEATURES", "COMMENT", "OYSTER", "ChatGPT"],
  rowData: [
    {
      Feature: "AI Tech",
      Comment:
        "Oyster harnesses advanced language AI, complemented by specialised best practices and templates designed for specific use cases. ",
      Oyster: "GPT-4 + Proprietary",
      Platform: "OpenAI ",
    },
    {
      Feature: "Output quality ",
      Comment:
        "Oyster delivers a superior, professionally polished output that demands minimal to no editing.  ",
      Oyster: "9/10 ",
      Platform: "9 ",
    },
    {
      Feature: "Editor ",
      Comment:
        "Oyster presents a straightforward document-style editor, creating an environment free from distractions, ideal for seamless long-form writing. Perfect for crafting blogs, articles, essays, and more. ",
      Oyster: "Yes",
      Platform: "No",
    },
    {
      Feature: "Workflow Management ",
      Comment:
        "Oyster lets you easily organise and structure your work in documents for better management, editing, and sharing  ",
      Oyster: "Yes",
      Platform: "No",
    },
    {
      Feature: "Supported use cases ",
      Comment:
        "Oyster supports a wide range of commonly sought-after use cases. It also offers unique, exclusive functionalities that sets it apart from other platforms.  ",
      Oyster: "50+ cases Upcoming ",
      Platform: "NA",
    },
    {
      Feature: "Supported languages ",
      Comment:
        "Access support for all major languages with Oyster, leveraging its proprietary methodology for generating outputs in different languages to guarantee superior quality.",
      Oyster: "15+ languages Upcoming ",
      Platform: "NA",
    },

    {
      Feature: "Browser extension ",
      Comment:
        "An extension that seamlessly integrates with your web activities, whether it's email, social media, document editing, WordPress, or other online tasks. ",
      Oyster: "Upcoming ",
      Platform: "No",
    },
    {
      Feature: "Plagiarism Checker ",
      Comment:
        "Oyster incorporates a built-in plagiarism checker to instantly assess the originality of generated content and provide prompt feedback. ",
      Oyster: "Yes + report can be downloaded as a pdf file ",
      Platform: "No",
    },
    {
      Feature: "SEO",
      Comment:
        "Oyster includes an integrated SEO toolkit designed for seamless optimization of long-form content as you write, supporting up to 10 long-tail and 10 short-tail keywords. ",
      Oyster: "Yes + Proprietary ",
      Platform: "Basic",
    },
    {
      Feature: "Customer support ",
      Comment:
        "Oyster provides exceptionally swift, dependable, and friendly customer support, actively soliciting continuous feedback from customers. Ticket resolutions are typically achieved within 12 hours. ",
      Oyster: "Upcoming  ",
      Platform: "  8/10 ",
    },
    {
      Feature: "Community",
      Comment:
        "Join an exclusive community tailored for entrepreneurs and startups, offering insights not only on writing but also on marketing strategies and business development.",
      Oyster: "Upcoming ",
      Platform: "No official community ",
    },
    {
      Feature: "Character limits ",
      Comment:
        "With Oyster's premium plan, you have the freedom to generate an unlimited number of characters every month. ",
      Oyster: "Unlimited ",
      Platform: "Unlimited",
    },
    {
      Feature: "Mobile Friendly ",
      Comment:
        "Oyster boasts lightning-fast speed and complete mobile optimisation, enabling you to write and edit seamlessly on the move without overlooking any crucial details. ",
      Oyster: "Yes",
      Platform: "Yes",
    },
    {
      Feature: "Free trial ",
      Comment:
        "Oyster extends a lifetime free plan, enabling you to generate up to 10,000 characters monthly without the necessity of a credit card. ",
      Oyster:
        "10k characters per month forever without a credit card requirement ",
      Platform: "Unlimited ",
    },
    {
      Feature: "Monthly price",
      Comment:
        "Oyster stands out as an exceptionally cost-effective tool, providing excellent value for money through its quality and features. ",
      Oyster: "$13 ",
      Platform: "Free",
    },
    {
      Feature: "Annual price ",
      Comment:
        "Subscribe to Oyster's premium annual plan for access to outstanding features at a budget-friendly price. ",
      Oyster: "$130 ",
      Platform: "Free",
    },
  ],
};

export const table5 = {
  title: "Oyster vs. Grammarly ",
  row: ["FEATURES", "COMMENT", "OYSTER", "Grammarly"],
  rowData: [
    {
      Feature: "AI Tech",
      Comment:
        "Oyster harnesses advanced language AI, complemented by specialised best practices and templates designed for specific use cases. ",
      Oyster: "GPT-4 + Proprietary",
      Platform: "Proprietary",
    },
    {
      Feature: "Output quality ",
      Comment:
        "Oyster delivers a superior, professionally polished output that demands minimal to no editing.  ",
      Oyster: "9/10 ",
      Platform: "9/10 ",
    },
    {
      Feature: "Editor ",
      Comment:
        "Oyster presents a straightforward document-style editor, creating an environment free from distractions, ideal for seamless long-form writing. Perfect for crafting blogs, articles, essays, and more. ",
      Oyster: "Yes",
      Platform: "Yes",
    },
    {
      Feature: "Workflow Management ",
      Comment:
        "Oyster lets you easily organise and structure your work in documents for better management, editing, and sharing  ",
      Oyster: "Yes",
      Platform: "Yes",
    },
    {
      Feature: "Supported use cases ",
      Comment:
        "Oyster supports a wide range of commonly sought-after use cases. It also offers unique, exclusive functionalities that sets it apart from other platforms.  ",
      Oyster: "50+ cases Upcoming ",
      Platform: "Only grammar and readability related ",
    },
    {
      Feature: "Supported languages ",
      Comment:
        "Access support for all major languages with Oyster, leveraging its proprietary methodology for generating outputs in different languages to guarantee superior quality.",
      Oyster: "15+ languages Upcoming ",
      Platform: "English primarily ",
    },

    {
      Feature: "Browser extension ",
      Comment:
        "An extension that seamlessly integrates with your web activities, whether it's email, social media, document editing, WordPress, or other online tasks. ",
      Oyster: " Upcoming ",
      Platform: "Yes",
    },
    {
      Feature: "Plagiarism Checker ",
      Comment:
        "Oyster incorporates a built-in plagiarism checker to instantly assess the originality of generated content and provide prompt feedback. ",
      Oyster: "Yes + report can be downloaded as a pdf file ",
      Platform: "Yes",
    },
    {
      Feature: "SEO",
      Comment:
        "Oyster includes an integrated SEO toolkit designed for seamless optimization of long-form content as you write, supporting up to 10 long-tail and 10 short-tail keywords. ",
      Oyster: "Yes + Proprietary ",
      Platform: "No",
    },
    {
      Feature: "Customer support ",
      Comment:
        "Oyster provides exceptionally swift, dependable, and friendly customer support, actively soliciting continuous feedback from customers. Ticket resolutions are typically achieved within 12 hours. ",
      Oyster: "Upcoming  ",
      Platform: "  9/10 ",
    },
    {
      Feature: "Community",
      Comment:
        "Join an exclusive community tailored for entrepreneurs and startups, offering insights not only on writing but also on marketing strategies and business development.",
      Oyster: "Upcoming ",
      Platform: "No",
    },
    {
      Feature: "Character limits ",
      Comment:
        "With Oyster's premium plan, you have the freedom to generate an unlimited number of characters every month. ",
      Oyster: "Unlimited ",
      Platform: "No ",
    },
    {
      Feature: "Mobile Friendly ",
      Comment:
        "Oyster boasts lightning-fast speed and complete mobile optimisation, enabling you to write and edit seamlessly on the move without overlooking any crucial details. ",
      Oyster: "Yes",
      Platform: "Yes",
    },
    {
      Feature: "Free trial ",
      Comment:
        "Oyster extends a lifetime free plan, enabling you to generate up to 10,000 characters monthly without the necessity of a credit card. ",
      Oyster:
        "10k characters per month forever without a credit card requirement ",
      Platform: "Yes",
    },
    {
      Feature: "Monthly price",
      Comment:
        "Oyster stands out as an exceptionally cost-effective tool, providing excellent value for money through its quality and features. ",
      Oyster: "$13 ",
      Platform: "$12 per month ",
    },
    {
      Feature: "Annual price ",
      Comment:
        "Subscribe to Oyster's premium annual plan for access to outstanding features at a budget-friendly price. ",
      Oyster: "$130 ",
      Platform: "-",
    },
  ],
};
